import { gql } from '@apollo/client';

export const GET_RELEASE_FEATURES = gql`
    query getReleaseFeatures($input: GetReleaseFeaturesInput) {
        getReleaseFeatures(input: $input) {
            type
            version
            path
            content
            tags
        }
    }
`;
